import ResourceStore from "@shared/services/ResourceStore";

class PaymentStore extends ResourceStore {
  _baseUrl (_params) {
    return "/api/v4";
  }

  async initializeSession (invoiceID) {
    let response = await fetch(
      `/api/v4/mpgs_payment/${invoiceID}/initialize_session`);

    return response.json();
  }

  async processPayment (invoiceID, data, paymentMethodId) {
    let response = await fetch(
      `/api/v4/checkout_payment/${invoiceID}/pay?payment_method_id=${paymentMethodId}&expiry_month=${data["expiry_month"]}&expiry_year=${data["expiry_year"]}&last4=${data["last4"]}`, {
        body: new FormData(document.getElementById("form-card")),
        method: "PUT"
      });

    return response.json();
  }

  async processMPGSPayment (invoiceID, data, paymentMethodId) {
    let response = await fetch(
      `/api/v4/mpgs_payment/${invoiceID}/checkout?payment_method_id=${paymentMethodId}&response_details[expiry_month]=${data["expiry_month"]}&response_details[expiry_year]=${data["expiry_year"]}&response_details[card_number]=${data["card_number"]}&response_details[response_status]=${data["response_status"]}&session_reference=${data["session_reference"]}`
    );

    return response.json();
  }

  async confirmInvoice (invoiceHash) {
    let response = await fetch(`/api/v4/invoices/${invoiceHash}/confirm`, {
      body: new FormData(document.getElementById("invoice-confirmation-form")),
      method: "PATCH"
    });

    let responseJSON = await response.json();

    return responseJSON;
  }
};

export default new PaymentStore("checkout_payment");
